import React from 'react';

// React.lazy com uma recarga automática quando o pedaço de JS/CSS não existe mais.
// Depois de um deploy, os chunks antigos somem; quem estava com o painel aberto e
// abre uma aba ainda não carregada recebe ChunkLoadError. Recarrega a página UMA
// vez (flag em sessionStorage) para pegar o index.html novo; se falhar de novo,
// propaga o erro. No sucesso a flag é limpa, para valer no próximo deploy.
const FLAG = 'care-chunk-reload';

export default function lazyWithRetry(factory) {
  return React.lazy(() =>
    factory()
      .then((mod) => {
        try { sessionStorage.removeItem(FLAG); } catch (e) { /* storage bloqueado */ }
        return mod;
      })
      .catch((err) => {
        const chunk = /ChunkLoadError|Loading (CSS )?chunk/i.test(String(err && (err.name + ' ' + err.message)));
        let ja = false;
        try { ja = sessionStorage.getItem(FLAG) === '1'; } catch (e) { /* storage bloqueado */ }
        if (chunk && !ja) {
          // Sem storage não há como lembrar que já recarregou: não recarrega
          // (evita laço infinito de reload) e deixa o erro subir.
          let gravou = false;
          try { sessionStorage.setItem(FLAG, '1'); gravou = true; } catch (e) { /* storage bloqueado */ }
          if (!gravou) throw err;
          window.location.reload();
          return new Promise(() => {});
        }
        throw err;
      })
  );
}
